var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGVentures(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.657,
    height: 28,
    viewBox: "0 0 96.657 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GVentures_Logo_Hori_RD",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108946",
    "data-name": "Path 108946",
    d: "M84.919,22.768V21.562l-1.171,1.206h-3.5L79.082,21.63V16.755L80.251,15.6h6v1.325H80.416v2.473l.875-.875h3.793l1.169,1.159v3.09Zm-1.755-1.335,1.589-1.589H80.416v1.589Z",
    transform: "translate(-48.591 -9.583)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108947",
    "data-name": "Path 108947",
    d: "M106.767,22.768V19.844h-4.5v2.924H100.93V16.755l1.159-1.159h4.864l1.149,1.149v6.023Zm0-5.847h-4.5v1.6h4.5Z",
    transform: "translate(-62.016 -9.583)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108948",
    "data-name": "Path 108948",
    d: "M128.625,22.5V18.377l-2.261,2.261-2.251-2.261V22.5h-1.334V15.165l3.585,3.6,3.586-3.6V22.5Z",
    transform: "translate(-75.44 -9.318)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108949",
    "data-name": "Path 108949",
    d: "M144.626,22.767V15.6h7.191V16.92H145.96v1.6h5.857v1.324H145.96v1.589h5.857v1.335Z",
    transform: "translate(-88.865 -9.583)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108950",
    "data-name": "Path 108950",
    d: "M166.526,22.767V15.6H173.7V16.92H167.86v1.6H173.7v1.324H167.86v2.924Z",
    transform: "translate(-102.32 -9.583)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22281",
    "data-name": "Rectangle 22281",
    width: 1.334,
    height: 7.172,
    transform: "translate(72.629 6.013)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108951",
    "data-name": "Path 108951",
    d: "M79.082,42.323V38.728h1.334v3.062l2.252,2.28L84.929,41.8V38.728h1.324v3.625l-3.586,3.6Z",
    transform: "translate(-48.591 -23.796)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108952",
    "data-name": "Path 108952",
    d: "M100.93,45.9V38.729h7.191v1.325h-5.857v1.6h5.857v1.324h-5.857v1.589h5.857V45.9Z",
    transform: "translate(-62.016 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108953",
    "data-name": "Path 108953",
    d: "M128.677,45.9V40.053h-4.513V45.9H122.83V38.729H130V45.9Z",
    transform: "translate(-75.472 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108954",
    "data-name": "Path 108954",
    d: "M147.6,45.9V40.053h-2.923V38.729h7.171v1.325h-2.923V45.9Z",
    transform: "translate(-88.896 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108955",
    "data-name": "Path 108955",
    d: "M167.694,45.9l-1.169-1.169v-6h1.334v5.837h4.493V38.729h1.334v6.024L172.518,45.9Z",
    transform: "translate(-102.32 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108956",
    "data-name": "Path 108956",
    d: "M194.195,45.9V42.977h-4.513V45.9h-1.334V38.729h6.012l1.159,1.159v1.93l-.5.5.5.5V45.9Zm0-5.847h-4.513v1.6h4.513Z",
    transform: "translate(-115.729 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108957",
    "data-name": "Path 108957",
    d: "M210.2,45.9V38.729h7.191v1.325H211.53v1.6h5.857v1.324H211.53v1.589h5.857V45.9Z",
    transform: "translate(-129.153 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108958",
    "data-name": "Path 108958",
    d: "M233.253,38.729l-1.159,1.159v1.941l1.159,1.149h4.688v1.588h-5.847V45.9h6.012l1.159-1.159V42.8l-1.149-1.149h-4.688v-1.6h5.837V38.729Z",
    transform: "translate(-142.609 -23.797)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108959",
    "data-name": "Path 108959",
    d: "M21.312,0,14.826,3.552,10.656,5.841V13.5l4.169-2.316v-3l2.317-1.27v5.617l-6.486,3.731L4.17,12.535v-5.6L8.34,9.23V4.6L0,0V14.8l1.26.7,9.4,5.4,9.395-5.4,1.261-.7V0Z",
    transform: "translate(0)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108960",
    "data-name": "Path 108960",
    d: "M10.656,50.838,0,44.709v4.633l10.656,6.129,10.656-6.129V44.709Z",
    transform: "translate(0 -27.471)",
    fill: "#1228f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGVentures);
export default __webpack_public_path__ + "static/media/G-ventures.19c4353269da2d7a321dbf632ab99608.svg";
export { ForwardRef as ReactComponent };